import GenericHeader from "../../Componentes/GenericHeader"
import FilterContainer from "../../Componentes/Utils/FilterContainer";
import Filters from "../../Componentes/Utils/Filters";
import Stats from "../../Componentes/Utils/Stats";
import Tabela from "../../Componentes/Utils/Tabela"
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { useModal } from "../../contexts/ModalContext";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import ModalRepEdit from "./ModalRepEdit";
import ModalRepQuartos from "./ModalRepQuartos";
import ModalDeleteRep from "./ModalDeleteRep";
import { VerifyPermission } from "../../Funcoes/VerifyPermission";
import { AuthContext } from "../../Auth/AuthProvider";

import useApi from "../../hooks/useApi";
const TableCell = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`;
const ActionsCell = styled.td`
    display: flex;
    gap: 12px;
    justify-content: center;
    height: 38px;
    padding: 0 25px !important;
`
const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 18px;
        transition: color 0.2s;
    }

    &:hover svg {
        color: ${(props) => props.hoverColor || "#000"};
    }
`;
const StatusCell = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => {
        if (props.status === 1) return "#00b809";
        if (props.status === 0) return "#a51a1a";
        return "#000"
    }};
    margin-left: 10px;
`
const ContainerStats = styled.div`
    display: flex;
    flex-direction: column;
    margin: auto;
`
const TituloStats = styled.h2`
    font-size: 16px;
    margin: 0 auto 5px auto;
`
const ValoresStats = styled.p`
    font-size: 14px;
    margin: 0 auto;
`

const BodyContent = () => {
    const api = useApi();


    const { user } = useContext(AuthContext);
    const { isModalOpen, closeModal, openModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [republicas, setRepublicas] = useState([]);
    const [repsFilter, setRepsFilter] = useState([]);

    const [selectedID, setSelectedID] = useState(null);
    const [selectedRep, setSelectedRep] = useState(null);

    const fetchReps = async () => {

        setLoading(true);

        try {

            const { data } = await api.get('/Painel/API/Republicas/GetRepublicas/')
            console.log(data)

            setRepsFilter(data);
            setRepublicas(data);

        } catch (e) {

            console.log(e)

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchReps();

    }, [])

    const FecharSideBar = () => {

        closeModal();

    }

    const OpenEditModal = (id = null) => {

        setSelectedID(id);
        openModal('editItem');

    }

    const openRepView = (rep) => {

        setSelectedRep(rep);
        openModal('viewRep');

    }

    const openRepDelete = (rep) => {

        setSelectedRep(rep)
        openModal('deleteRep')

    }

    const valoresStats = repsFilter.reduce(
        (acc, rep) => {
            acc.quartos += rep.quartos || 0;
            acc.vagas += Number(rep.vagas) || 0;
            acc.total_pessoas += Number(rep.total_pessoas) || 0;
            return acc;
        },
        { quartos: 0, vagas: 0, total_pessoas: 0 }
    );

    useEffect(() => {

        console.log( valoresStats );

    }, [ valoresStats ])

    const formatNumber = (value) => {
        return new Intl.NumberFormat('pt-BR').format(value);
    };

    const listaCc = useMemo(() => [...new Set(republicas.map((obj) => obj.centro_custo))].sort(), [republicas]);

    const [repValue, setRepValue] = useState("");
    const [ccValue, setCcValue] = useState([]);
    const [statusValue, setStatusValue] = useState([]);
    const [vagasValue, setVagasValue] = useState([]);

    const handleFilter = useCallback(() => {
        setRepsFilter(
            republicas.filter((item) => {
                const apelido = item.apelido_rep ?? ''
                const nomeRep = !repValue || apelido.toLowerCase().includes(repValue.toLowerCase())
                const ccRep = !ccValue.length || ccValue.some(obj => (item.centro_custo || '').includes(obj.value))

                const statusRep = !statusValue.length || statusValue.some((obj) =>
                    obj.value === 'ATIVO' ? item.ativo === 1 : item.ativo === 0
                )

                const vagasRep = !vagasValue.length || vagasValue.some((obj) =>
                    obj.value === "COM VAGAS DISPONÍVEIS" ? Number(item.vagas) > item.total_pessoas : Number(item.vagas) === item.total_pessoas
                )

                return nomeRep && ccRep && statusRep && vagasRep;
            })
        )
    }, [republicas, repValue, ccValue, statusValue, vagasValue]);

    useEffect(() => {
        handleFilter();
    }, [handleFilter])

    return (
        <>
            <GenericHeader>
                <Filters columns={2} >
                    <FilterContainer
                        type="text"
                        placeholder="REPÚBLICA..."
                        valor={repValue}
                        changeFunc={(value) => setRepValue(value.toUpperCase())}
                    />
                    <FilterContainer
                        type="select"
                        options={listaCc}
                        optType={'obj'}
                        placeholder="CENTRO CUSTO..."
                        valor={ccValue}
                        changeFunc={(value) => setCcValue(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={[
                            "ATIVO",
                            "INATIVO"
                        ]}
                        optType={'obj'}
                        placeholder="STATUS..."
                        valor={statusValue}
                        changeFunc={(value) => setStatusValue(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={[
                            "COM VAGAS DISPONÍVEIS",
                            "SEM VAGAS DISPONÍVEIS"
                        ]}
                        optType={'obj'}
                        placeholder="DISPONIBILIDADE DE VAGAS..."
                        valor={vagasValue}
                        changeFunc={(value) => setVagasValue(value)}
                    />
                </Filters>
                <Stats>
                    <ContainerStats>
                        <TituloStats>REPÚBLICAS: {formatNumber(repsFilter.length)}</TituloStats>
                        <ValoresStats>QUARTOS: {formatNumber(valoresStats.quartos)}</ValoresStats>
                        <ValoresStats>ALOJADOS: {formatNumber(valoresStats.total_pessoas)}/{formatNumber(valoresStats.vagas)}</ValoresStats>
                        <ValoresStats>VAGAS: {formatNumber(valoresStats.vagas - valoresStats.total_pessoas)}</ValoresStats>
                    </ContainerStats>
                </Stats>
            </GenericHeader>
            <Tabela loading={loading} >
                <thead>
                    <tr>
                        <th></th>
                        <th>REPÚBLICA</th>
                        <th>CENTRO DE CUSTO</th>
                        <th>ENDEREÇO</th>
                        <th>COMPLEMENTO</th>
                        <th>LOCALIZAÇÃO</th>
                        <th>QUARTOS</th>
                        <th>VAGAS</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {repsFilter.map((obj, index) => (
                        <tr key={index} >
                            <td><StatusCell status={obj.ativo} /></td>
                            <td>{obj.apelido_rep}</td>
                            <td>{obj.centro_custo}</td>
                            <td>{`${obj.logradouro}, ${obj.numero}`}</td>
                            <td>{obj.complemento ? obj.complemento : "-"}</td>
                            <td>{`${obj.bairro} - ${obj.cidade}/${obj.estado}`}</td>
                            <TableCell align="center" >{obj.quartos}</TableCell>
                            <TableCell align="center" >{`${obj.total_pessoas}/${obj.vagas}`}</TableCell>
                            <ActionsCell>
                                <IconButton
                                    hoverColor="#16a34a"
                                    onClick={() => openRepView(obj)}
                                >
                                    <FaEye />
                                </IconButton>
                                <IconButton
                                    hoverColor="#1d4ed8"
                                    onClick={() => OpenEditModal(obj.id)}
                                >
                                    <FaEdit />
                                </IconButton>
                                {
                                    VerifyPermission(user, { modulo: 'rh', submodulo: 'republicas', funcao: 'delete-rep' }) && (
                                        <IconButton
                                            hoverColor="#dc2626"
                                            onClick={() => openRepDelete(obj)}
                                        >
                                            <FaTrash />
                                        </IconButton>
                                    )
                                }
                            </ActionsCell>
                        </tr>
                    ))}
                </tbody>
            </Tabela>
            {isModalOpen('sidebarOverlay') && (
                <Overlay state={true} changeContent={FecharSideBar} >
                    <SideMenu>
                        <SideMenuBtn
                            button="NOVA REPÚBLICA"
                            clickFunc={() => {
                                closeModal();
                                OpenEditModal();
                            }}
                        />
                    </SideMenu>
                </Overlay>
            )}
            {isModalOpen('editItem') && (
                <ModalRepEdit
                    id={selectedID}
                    fetchSuccess={fetchReps}
                />
            )}
            {isModalOpen('viewRep') && (
                <ModalRepQuartos
                    rep={selectedRep}
                    fetchReps={fetchReps}
                />
            )}
            {
                isModalOpen('deleteRep') && (
                    <ModalDeleteRep
                        rep={selectedRep}
                        fetchSuccess={fetchReps}
                    />
                )
            }
        </>
    )

}

export default BodyContent;